import * as React from 'react';
import {connect} from 'react-redux';
import {Card} from "react-bootstrap";
import {ResponsiveLine} from "@nivo/line";
import {boolean, select} from '@storybook/addon-knobs'
import _ from "lodash";
import {Md5} from "ts-md5";
import * as moment from "moment-timezone";

/**
 * Props
 *
 */
type Props = {
    dataAnalyticsTemposAtendimento: DataAnalyticsTemposAtendimento;
    type: "PARTICULAR" | "CONVENIO";
};

/**
 * State
 *
 */
type State = {
    dataAnalyticsTemposAtendimentoParticularMinimo: DataAnalyticsTemposAtendimentoLine;
    dataAnalyticsTemposAtendimentoParticularMedio: DataAnalyticsTemposAtendimentoLine;
    dataAnalyticsTemposAtendimentoParticularMaximo: DataAnalyticsTemposAtendimentoLine;
    dataAnalyticsTemposAtendimentoConvenioMinimo: DataAnalyticsTemposAtendimentoLine;
    dataAnalyticsTemposAtendimentoConvenioMedio: DataAnalyticsTemposAtendimentoLine;
    dataAnalyticsTemposAtendimentoConvenioMaximo: DataAnalyticsTemposAtendimentoLine;
    timeDetails: TimesDetails;
    hashProps: string;
    hasData: boolean;
}

/**
 * Data chart pacientes
 *
 */
interface DataAnalyticsTemposAtendimento {
    particularData: DataAnalyticsTemposAtendimentoDetails[];
    convenioData: DataAnalyticsTemposAtendimentoDetails[];
}

/**
 * Data chart pacientes
 *
 */
interface DataAnalyticsTemposAtendimentoDetails {
    period: string;
    minimo: number;
    medio: number;
    maximo: number;
}

/**
 * DataAnalyticsTemposAtendimentoLine
 *
 */
interface DataAnalyticsTemposAtendimentoLine {
    id: string;
    data: DataAnalyticsTemposAtendimentoLinePosition[];
}

/**
 * DataAnalyticsTemposAtendimentoLinePosition
 *
 */
interface DataAnalyticsTemposAtendimentoLinePosition {
    x: string;
    y: number;
}

/**
 * Responsible time details
 *
 */
interface TimesDetails {
    xScaleFormat: string;
    legendLabel: string;
    xAxisBottomFormat: string;
}

/**
 * State Data
 */
interface StateDate {
    dataAnalyticsTemposAtendimentoMinimo: DataAnalyticsTemposAtendimentoLine;
    dataAnalyticsTemposAtendimentoMedio: DataAnalyticsTemposAtendimentoLine;
    dataAnalyticsTemposAtendimentoMaximo: DataAnalyticsTemposAtendimentoLine;
}

/**
 * Get Custom Symbol
 *
 * @param size - size
 * @param color - color
 * @param borderWidth - borderWidth
 * @param borderColor - borderColor
 * @returns {JSX.Element}
 * @constructor
 */
const CustomSymbol = ({size, color, borderWidth, borderColor}) => (
    <g>
        <circle fill="#fff" r={size / 2} strokeWidth={borderWidth} stroke={borderColor}/>
        <circle
            r={size / 5}
            strokeWidth={borderWidth}
            stroke={borderColor}
            fill={color}
            fillOpacity={0.35}
        />
    </g>
);

/**
 * Curve options
 *
 * @type {string[]}
 */
const curveOptions = ['linear', 'monotoneX', 'step', 'stepBefore', 'stepAfter']

/**
 * Chart Dashboard Component
 *
 */
class ChartTemposAtendimentoAnalyticsDashboardComponent extends React.Component<Props, State> {

    /**
     * Default constructor
     *
     * @param props
     */
    constructor(props: any) {
        super(props);
        this.state = this.getInitialState();
    }

    /**
     * Responsible change componente.
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
        let newHashProps: string = this.generateHasProps(
            this.props.dataAnalyticsTemposAtendimento
        );
        if (newHashProps !== prevState.hashProps) {
            this.setState(this.getInitialState());
        }
    }

    /**
     * Responsible get initial state
     *
     * @return {{showSyntheticData: (boolean|boolean), showAnalyticData: (boolean|boolean), syntheticData: SyntheticData, analyticData: Analytic[]}}
     */
    getInitialState(): any {
        let particularData: StateDate = this.getStateData(this.props.dataAnalyticsTemposAtendimento.particularData, "particular");
        let convenioData: StateDate = this.getStateData(this.props.dataAnalyticsTemposAtendimento.convenioData, "convenio");
        return {
            timeDetails: this.getTimesDetails(),
            dataAnalyticsTemposAtendimentoParticularMinimo: particularData.dataAnalyticsTemposAtendimentoMinimo,
            dataAnalyticsTemposAtendimentoParticularMedio: particularData.dataAnalyticsTemposAtendimentoMedio,
            dataAnalyticsTemposAtendimentoParticularMaximo: particularData.dataAnalyticsTemposAtendimentoMaximo,
            dataAnalyticsTemposAtendimentoConvenioMinimo: convenioData.dataAnalyticsTemposAtendimentoMinimo,
            dataAnalyticsTemposAtendimentoConvenioMedio: convenioData.dataAnalyticsTemposAtendimentoMedio,
            dataAnalyticsTemposAtendimentoConvenioMaximo: convenioData.dataAnalyticsTemposAtendimentoMaximo,
            hashProps: this.generateHasProps(
                this.props.dataAnalyticsTemposAtendimento
            ),
            hasData: this.hasData()
        };
    }

    /**
     * Responsible generate hash.
     *
     * @param dataAnalyticsTemposAtendimento
     * @return {string}
     */
    generateHasProps = (dataAnalyticsTemposAtendimento: DataAnalyticsTemposAtendimento): string => {
        return Md5.hashStr(
            JSON.stringify(dataAnalyticsTemposAtendimento)
        )
    }

    /**
     *
     * Responsible validate if has data.
     *
     * @return {boolean}
     */
    hasData = (): boolean => {
       // return this.props.type === "PARTICULAR" ? [
       //      this.state.dataAnalyticsTemposAtendimentoParticularMinimo,
       //      this.state.dataAnalyticsTemposAtendimentoParticularMedio,
       //      this.state.dataAnalyticsTemposAtendimentoParticularMaximo
       //  ] : [
       //      this.state.dataAnalyticsTemposAtendimentoConvenioMinimo,
       //      this.state.dataAnalyticsTemposAtendimentoConvenioMedio,
       //      this.state.dataAnalyticsTemposAtendimentoConvenioMaximo
       //  ]
        console.log(this.props.dataAnalyticsTemposAtendimento)
        return this.props.dataAnalyticsTemposAtendimento
            && (
                (_.filter(this.props.dataAnalyticsTemposAtendimento.convenioData,(d)=>{return d.minimo&&d.medio&&d.maximo}) && _.filter(this.props.dataAnalyticsTemposAtendimento.convenioData,(d)=>{return d.minimo&&d.medio&&d.maximo}).length > 0)
                || (_.filter(this.props.dataAnalyticsTemposAtendimento.particularData,(d)=>{return d.minimo&&d.medio&&d.maximo}) && _.filter(this.props.dataAnalyticsTemposAtendimento.particularData,(d)=>{return d.minimo&&d.medio&&d.maximo}).length > 0)
            )
    }

    /**
     * Responsible get times details
     *
     * @returns {string}
     */
    getTimesDetails(): TimesDetails {
        if (this.props.dataAnalyticsTemposAtendimento && this.props.dataAnalyticsTemposAtendimento.particularData && this.props.dataAnalyticsTemposAtendimento.particularData[0].period) {
            if (this.props.dataAnalyticsTemposAtendimento.particularData[0].period.length === 10) {
                return {
                    xScaleFormat: "%Y-%m-%d",
                    legendLabel: "Dias",
                    xAxisBottomFormat: "%d-%m-%Y"
                };
            } else if (this.props.dataAnalyticsTemposAtendimento.particularData[0].period.length === 7) {
                return {
                    xScaleFormat: "%Y-%m",
                    legendLabel: "Meses",
                    xAxisBottomFormat: "%m-%Y"
                };
            } else {
                return {
                    xScaleFormat: "%Y",
                    legendLabel: "Anos",
                    xAxisBottomFormat: "%Y"
                };
            }
        } else {
            return {
                xScaleFormat: "%Y-%m-%d",
                legendLabel: "Dias",
                xAxisBottomFormat: "%d-%m-%Y"
            };
        }
    }

    /**
     * Get state data.
     *
     * @param data - data
     * @param label - label
     * @return StateDate
     */
    getStateData(data: DataAnalyticsTemposAtendimentoDetails[], label: string): StateDate {
        if (data) {
            let minimo: DataAnalyticsTemposAtendimentoLinePosition[] = [];
            let medio: DataAnalyticsTemposAtendimentoLinePosition[] = [];
            let maximo: DataAnalyticsTemposAtendimentoLinePosition[] = [];
            _.forEach(data, function (dataDetails: DataAnalyticsTemposAtendimentoDetails) {
                if (moment.tz(dataDetails.period, "America/Sao_Paulo")
                        .isSameOrBefore(moment.tz(new Date(), "America/Sao_Paulo"))
                    && (dataDetails.minimo > 0 || dataDetails.medio > 0 || dataDetails.maximo > 0)) {
                    if (dataDetails.minimo > 0) {
                        minimo.push({
                            x: dataDetails.period,
                            y: dataDetails.minimo ? dataDetails.minimo : 0
                        });
                    }
                    if (dataDetails.medio > 0) {
                        medio.push({
                            x: dataDetails.period,
                            y: dataDetails.medio ? dataDetails.medio : 0
                        });
                    }
                    if (dataDetails.maximo > 0) {
                        maximo.push({
                            x: dataDetails.period,
                            y: dataDetails.maximo ? dataDetails.maximo : 0
                        });
                    }
                }
            });
            return {
                dataAnalyticsTemposAtendimentoMinimo: {
                    id: `minimo`,
                    data: minimo
                },
                dataAnalyticsTemposAtendimentoMedio: {
                    id: `medio`,
                    data: medio
                },
                dataAnalyticsTemposAtendimentoMaximo: {
                    id: `maximo`,
                    data: maximo
                }
            }
        } else {
            return {
                dataAnalyticsTemposAtendimentoMinimo: null,
                dataAnalyticsTemposAtendimentoMedio: null,
                dataAnalyticsTemposAtendimentoMaximo: null
            }
        }
    }

    formatSliceX = ({slice}) => {
        if(slice && slice.points && slice.points.length > 0) {
            return (
                <div
                    style={{
                        background: 'white',
                        padding: '9px 12px',
                        border: '1px solid #ccc',
                    }}
                >
                    <div>Período: {this.formatDateTooltip(slice.points[0].data.x)}</div>
                    {slice.points.map(point => (
                        <div
                            key={point.id}
                            style={{
                                color: point.serieColor,
                                padding: '3px 0',
                            }}
                        >
                            <strong>{point.serieId}</strong> [{point.data.yFormatted}]
                        </div>
                    ))}
                </div>
            )
        }else {
            return (<div></div>)
        }
    }

    formatDateTooltip = (date: Date) => {
        let tempArray: Array<string> = [];
        let timeDetails: string = this.getTimesDetails().legendLabel;
        if(date.getDate() && "Dias" === timeDetails) {
            tempArray.push(this.padTo2Digits(date.getDate()));
        }
        if((date.getMonth() + 1) && ("Dias" === timeDetails || "Meses" === timeDetails)) {
            tempArray.push(this.padTo2Digits(date.getMonth() + 1));
        }
        if(date.getFullYear() && ("Dias" === timeDetails || "Meses" === timeDetails || "Anos" === timeDetails)) {
            tempArray.push(this.padTo2Digits(date.getFullYear()));
        }
        return tempArray.join('/');
    }

    padTo2Digits = (num: number) => {
        return num.toString().padStart(2, '0');
    }

    /**
     * Render component
     *
     * @returns {JSX.Element}
     */
    render() {
        console.log(this.state);
        return (
            <React.Fragment>
                <Card className="bg-light h-100">
                    <Card.Body className="chart-card-body">
                        <Card.Title
                            className="chart-card-title d-flex justify-content-center">Tempo Atendimento
                            - {this.props.type === "PARTICULAR" ? "Particular" : "Convenio"}</Card.Title>
                        {!this.state.hasData && (
                            <React.Fragment>
                                <div className="chart-text-blank justify-content-center">Não existem dados a serem
                                    exibidos para essa
                                    pesquisa.
                                </div>
                            </React.Fragment>
                        )}
                        {this.state.hasData && (
                            <React.Fragment>
                                <div className="chart-card-full">
                                    <ResponsiveLine
                                        height={500}
                                        margin={{top: 60, right: 110, bottom: 90, left: 80}}
                                        animate={true}
                                        colors={['#7c8657', '#b95722', '#831a26']}
                                        data={this.props.type === "PARTICULAR" ? [
                                            this.state.dataAnalyticsTemposAtendimentoParticularMinimo,
                                            this.state.dataAnalyticsTemposAtendimentoParticularMedio,
                                            this.state.dataAnalyticsTemposAtendimentoParticularMaximo
                                        ] : [
                                            this.state.dataAnalyticsTemposAtendimentoConvenioMinimo,
                                            this.state.dataAnalyticsTemposAtendimentoConvenioMedio,
                                            this.state.dataAnalyticsTemposAtendimentoConvenioMaximo
                                        ]}
                                        xScale={{
                                            type: 'time',
                                            format: this.state.timeDetails.xScaleFormat,
                                            useUTC: false,
                                            precision: this.state.timeDetails.legendLabel === "Dias" ? 'day' : this.state.timeDetails.legendLabel === "Meses" ? 'month' : 'year',
                                        }}
                                        yScale={{
                                            type: 'linear',
                                            stacked: boolean('stacked', false)
                                        }}
                                        axisBottom={{
                                            format: this.state.timeDetails.xAxisBottomFormat,
                                            legend: this.state.timeDetails.legendLabel,
                                            tickValues: this.state.timeDetails.legendLabel === "Dias" ? 'every day' : this.state.timeDetails.legendLabel === "Meses" ? 'every month' : 'every year',
                                            legendPosition: 'end',
                                            legendOffset: 65,
                                            tickRotation: -55
                                        }}
                                        axisLeft={{
                                            legend: 'Minutos',
                                            legendPosition: 'end',
                                            legendOffset: -60
                                        }}
                                        curve={select('curve', curveOptions, 'monotoneX')}
                                        enablePointLabel={true}
                                        pointSymbol={CustomSymbol}
                                        pointSize={16}
                                        pointBorderWidth={1}
                                        useMesh={true}
                                        enableSlices="x"
                                        pointBorderColor={{
                                            from: 'color',
                                            modifiers: [['darker', 0.3]],
                                        }}
                                        sliceTooltip={this.formatSliceX}
                                        legends={[
                                            {
                                                anchor: 'bottom-right',
                                                direction: 'column',
                                                toggleSerie: true,
                                                justify: false,
                                                translateX: 120,
                                                translateY: 0,
                                                itemsSpacing: 2,
                                                itemWidth: 100,
                                                itemHeight: 20,
                                                itemDirection: 'left-to-right',
                                                itemOpacity: 0.85,
                                                symbolSize: 20,
                                                effects: [
                                                    {
                                                        on: 'hover',
                                                        style: {
                                                            itemOpacity: 1
                                                        }
                                                    }
                                                ]
                                            }
                                        ]}
                                    />
                                </div>
                            </React.Fragment>
                        )}
                    </Card.Body>
                </Card>
            </React.Fragment>
        );
    }
}

/**
 * Export default connect
 *
 */
export default connect(null, null, null)(ChartTemposAtendimentoAnalyticsDashboardComponent);